import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { TABLE_PAGINATION_ROWS_OPTIONS,TABLE_PAGINATION_ROWS_OPTIONS_SELECTED } from "../../constants/commonConstants";

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                ) : (
                    <KeyboardArrowLeft />
                )}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                ) : (
                    <KeyboardArrowRight />
                )}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

const StyledTablePagination = styled(TablePagination)(() => ({
    ".MuiTablePagination-selectLabel": {
        color: "#444444",
        fontWeight: "500",
        fontSize: "15px",
    },
    ".MuiTablePagination-select": {
        border: "1px solid #777",
        borderRadius: "4px",
        color: "#000",
        fontWeight: "500",
    },
    ".MuiTablePagination-select:focus": {
        border: "2px solid #0086ff",
        borderRadius: "4px",
    },
    ".MuiTablePagination-displayedRows": {
        color: "#444444",
        fontWeight: "500",
        fontSize: "15px",
    },
    ".MuiTablePagination-menuItem": {
        background: "#fff",
        textAlign: "center",
    },
    ".MuiTablePagination-menuItem:hover": {
        background: "#f5f5f5",
    },
}));


const CommonTablePagination = (props) => {
    const { rowsPerPageOption = TABLE_PAGINATION_ROWS_OPTIONS, count = 0, rowsPerPage = TABLE_PAGINATION_ROWS_OPTIONS_SELECTED, page = 1, onPageChange, onRowsPerPageChange, className } = props
    return (
        <StyledTablePagination
            component="div"
            rowsPerPageOptions={rowsPerPageOption}
            colSpan={3}
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
                inputProps: {
                    "aria-label": "rows per page",
                },
                native: true,
            }}
            // classes={{ menuItem: classes.menuItem }}
            className={className}
            onPageChange={onPageChange}
            onRowsPerPageChange={onRowsPerPageChange}
            ActionsComponent={TablePaginationActions}
        />
    )
}
export default CommonTablePagination;